import { setLoanProcessingFlowId } from 'redux/store/slices/userSlice'
import type {
  GetScoringOkedsResponse,
  GetScoringOptionsResponse,
  SaveAdditionalDocumentsPayload,
  SaveAdditionalDocumentsResponse,
  SetApplicationDecisionPayload,
  SetApplicationDecisionResponse,
  SetApplicationPledgeDecisionPayload,
  SetApplicationPledgeDecisionResponse,
  SetScoringPaydayPayload,
  SetScoringPaydayResponse,
  SkipScoringUpgradeConditionsPayload,
  SkipScoringUpgradeConditionsResponse,
  UploadAdditionalDocsPayload,
  UploadAdditionalDocsResponse
} from 'share/types/api/main'

import { api } from '.'

const authApi = api.injectEndpoints({
  endpoints: build => ({
    getScoringOptions: build.query<GetScoringOptionsResponse, void>({
      query: () => ({
        url: '/scoring/options',
        method: 'get'
      })
    }),
    getScoringOkeds: build.query<GetScoringOkedsResponse, void>({
      query: () => ({
        url: '/scoring/okeds/',
        method: 'get'
      })
    }),
    setApplicationDecision: build.mutation<SetApplicationDecisionResponse, SetApplicationDecisionPayload>({
      query: ({ id, ...body }) => ({
        url: `/scoring/${id}/decision/`,
        method: 'post',
        body
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          dispatch(setLoanProcessingFlowId(data.data.flow_id))
        } catch (error) {
          console.log(error)
        }
      }
    }),
    setApplicationPledgeDecition: build.mutation<
      SetApplicationPledgeDecisionResponse,
      SetApplicationPledgeDecisionPayload
    >({
      query: ({ id, ...body }) => ({
        url: `/scoring/${id}/pledge_decision`,
        method: 'post',
        body
      })
    }),
    setScoringPayday: build.mutation<SetScoringPaydayResponse, SetScoringPaydayPayload>({
      query: ({ id, pay_day }) => ({
        url: `/scoring/${id}/set-pay-day/`,
        method: 'post',
        body: {
          pay_day
        }
      })
    }),
    saveAdditionalDocuments: build.mutation<SaveAdditionalDocumentsResponse, SaveAdditionalDocumentsPayload>({
      query: ({ id, body }) => ({
        url: `/scoring/${id}/save_additional_document/`,
        method: 'POST',
        body
      })
    }),
    skipUpgradeConditions: build.mutation<SkipScoringUpgradeConditionsResponse, SkipScoringUpgradeConditionsPayload>({
      query: ({ flow_id }) => ({
        url: `/scoring/${flow_id}/improve_params/skip/`,
        method: 'post'
      })
    }),
    uploadAdditionalDocuments: build.mutation<UploadAdditionalDocsResponse, UploadAdditionalDocsPayload>({
      query: ({ flow_id, formData }) => ({
        url: `/scoring/${flow_id}/upload_additional_document/`,
        method: 'post',
        body: formData
      })
    })
  })
})

export const {
  useGetScoringOptionsQuery,
  useLazyGetScoringOptionsQuery,
  useGetScoringOkedsQuery,
  useSetApplicationDecisionMutation,
  useSetScoringPaydayMutation,
  useSaveAdditionalDocumentsMutation,
  useSkipUpgradeConditionsMutation,
  useUploadAdditionalDocumentsMutation,
  useSetApplicationPledgeDecitionMutation
} = authApi
